import { Box, Button, Checkbox, Field, Heading, Link, List, Stack, Textarea } from '@chakra-ui/react';
import { EnrollmentList } from './EnrollmentList';
import { FiExternalLink } from 'react-icons/fi';
import { useState } from 'react';


export const SummaryView = (props: any) => {
	const { notes, setNotes, lessonsList, onSubmit, isSending } = props;
	const [agreementError, setAgreementError] = useState('');

	const agreements = [
		{
			name: 'Regulamin zajęć indywidualnych',
			link: '/static/assets/regulamin_lekcje_indywidualne_opanuj_to_2024.pdf',
			visible: lessonsList.some(
				(lesson: any) => lesson.kind === 'Korepetycje indywidualne'
			),
		},
		{
			name: 'Regulamin zajęć grupowych',
			link: '/static/assets/regulamin_lekcje_grupowe_opanuj_to_2024.pdf',
			visible: lessonsList.some(
				(lesson: any) => lesson.kind === 'Korepetycje grupowe'
			),
		},
		{
			name: 'Regulamin kursów maturalnych i ósmoklasisty',
			link: '/static/assets/regulamin_kursy_opanuj_to_2024.pdf',
			visible: lessonsList.some(
				(lesson: any) =>
					lesson.kind === 'Kurs maturalny' ||
					lesson.kind === 'Kurs ósmoklasisty'
			),
		},
	].filter(({ visible }) => visible);

	return (
		<Stack gap="4" mt={10} mx={{ base: 0, lg: '8%' }}>
			<EnrollmentList
				lessonList={lessonsList}
				actionType="none"
			/>

			<Box mt={4}>
				<Heading size="xs" textTransform="uppercase" mb={2}>
					{lessonsList.length === 1 ? 'Regulamin zajęć' : 'Regulamin zajęć'}
				</Heading>
				<List.Root
					as="ul"
					listStyleType="disc"
					pl={6}
					m={0}
					gap={2}
					color="black"
				>
					{agreements.map(({ name, link }) => (
						<List.Item key={name} pt="1" listStylePosition="outside" pl={1}>
							<Link
								fontSize="sm"
								color="mediumblue"
								href={link}
								display="inline-flex"
								alignItems="center"
								gap="1"
							>
								<span>{name}</span>
								<FiExternalLink />
							</Link>
						</List.Item>
					))}
				</List.Root>
				<Field.Root required invalid={Boolean(agreementError)} mt={3}>
					<Stack direction="row" align="start" gap={3}>
						<Checkbox.Root
							colorPalette="orange"
							checked={Boolean(props.statuteAccepted)}
							onCheckedChange={(details) => {
								setAgreementError('');
								props.setStatuteAccepted(details.checked === true);
							}}
						>
							<Checkbox.HiddenInput required />
							<Checkbox.Control>
								<Checkbox.Indicator />
							</Checkbox.Control>
						</Checkbox.Root>
						<Field.Label fontSize="sm" mb={0}>
							{agreements.length > 1 ? 'Oświadczam, że przeczytałem/am i akceptuję powyższe regulaminy' : 'Oświadczam, że przeczytałem/am i akceptuję powyższy regulamin'}
							<Field.RequiredIndicator />
						</Field.Label>
					</Stack>
					<Field.ErrorText>{agreementError}</Field.ErrorText>
				</Field.Root>

				<Box mt={10}>
					<Heading size="xs" textTransform="uppercase" mb={2}>
						Uwagi do rezerwacji
					</Heading>
					<Textarea
						value={notes}
						onChange={(event) => {
							setNotes(event.target.value);
						}}
					/>
				</Box>
				{onSubmit && (
					<Box mt={8}>
						<Button
							colorPalette="orange"
							onClick={() => {
								if (!props.statuteAccepted) {
									setAgreementError('Zapoznanie się z regulaminem jest wymagane przed złożeniem rezerwacji');
									return;
								}
								onSubmit();
							}}
							loading={isSending}
							disabled={lessonsList.length === 0}
							width="100%"
						>
							Rezerwuj
						</Button>
					</Box>
				)}
			</Box>
		</Stack>
	);
};
